import React, { useEffect, useState } from 'react';
import { AccessListItemNode, AccessScreenHeader } from 'screens/AuditScreens/components';
import { OpenLinksQuery } from 'services/apollo/auditQueries/auditQueries';
import { AuthLoader } from 'screens/LoginScreen';
import { useQuery } from '@apollo/react-hooks';
import { FeedListInfinitySpinner } from 'components';
import { useInView } from 'react-intersection-observer';
import { AccessFetchError } from '../components/AccessFetchError/AccessFetchError';
import { handleFetchMoreError } from 'services';
import { useTranslation } from 'react-i18next';

import auditLayoutStyles from 'screens/AuditScreens/screens/AuditLayout.module.scss';

export const OpenLinksAuditScreen = () => {
  const { t } = useTranslation();
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const { data, fetchMore, error } = useQuery(OpenLinksQuery, {
    variables: { first: 20, cursor: '' },
    fetchPolicy: 'cache-and-network',
  });

  const [ref, inView] = useInView({
    rootMargin: '500px 0px',
    threshold: 0,
  });

  useEffect(() => {
    if (inView === true) {
      triggerFetchMore().then((response) => response);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  const triggerFetchMore = async () => {
    setIsLoadingMore(true);
    const { endCursor } = data.documentSecurityAudit.openLinksAccess.pageInfo;

    try {
      await fetchMore({
        variables: { first: 20, cursor: endCursor },
        updateQuery: (prevResult: any, { fetchMoreResult }) => {
          fetchMoreResult.documentSecurityAudit.openLinksAccess.nodes = [
            ...prevResult.documentSecurityAudit.openLinksAccess.nodes,
            ...fetchMoreResult.documentSecurityAudit.openLinksAccess.nodes,
          ];
          setIsLoadingMore(false);
          return fetchMoreResult;
        },
      });
    } catch (e) {
      handleFetchMoreError(e);
    }
  };

  if (data === undefined) {
    return <AuthLoader type="DSA" />;
  }

  if (error) {
    return <AccessFetchError />;
  }

  return (
    <div className={auditLayoutStyles.screen}>
      <div className={auditLayoutStyles.header}>
        <AccessScreenHeader
          title={`${data.documentSecurityAudit.openLinksAccess.pageInfo.total.toLocaleString()} ${t(
            'openLinksScreen.title'
          )}`}
        />
      </div>
      {data.documentSecurityAudit.openLinksAccess.nodes.map((node: any, key: number) => (
        <AccessListItemNode
          key={key}
          buttonMessage={t('openLinksScreen.list-item-button')}
          node={node}
          type="Full"
          showIntegration={true}
        />
      ))}
      {data.documentSecurityAudit.openLinksAccess.pageInfo.hasNextPage && (
        <div ref={ref}>
          <FeedListInfinitySpinner isLoadingMore={isLoadingMore} />
        </div>
      )}
    </div>
  );
};
